import React, { useEffect, useState } from "react";
import {
  Switch,
  Navbar,
  NavbarBrand,
  NavbarContent,
  NavbarItem,
  Link, NavbarMenu, NavbarMenuItem, Button, NavbarMenuToggle,
  Select,
  SelectItem
} from "@nextui-org/react";

import Connect from "../Connect";
import Logo from "../Logo";
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { setLang } from "../../utils/lang";
import { MoonIcon } from "./MoonIcon";
import { SunIcon } from "./SunIcon";
import { useTheme } from "next-themes";

function Header() {
  const location = useLocation()
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { i18n, t } = useTranslation()
// Token白名单申请（暂未开放）
// SWAP横屏申请（暂未开放）
// WDE3链上商城(暂未开放)
// AI量化生态系统（暂未开放）
// RWA金融资产上链（暂未开放）
// 借贷理财（暂未开放）
// 跨链交易（暂未开放）
// 多元化生态系统（暂未开放）
  const menuItems = [
    { path: 'https://c2c.w3swap.vip', label:"OTC交易" },
    { path: '/#', label:"SWAP横屏申请（暂未开放）" },
    { path: '/#', label:"WEB3链上商城(暂未开放)" },
    { path: '/#', label:"AI量化生态系统（暂未开放）"},
    { path: '/#', label:"RWA金融资产上链（暂未开放）"},
    { path: '/#', label:"借贷理财（暂未开放）" },
    { path: '/#', label:"跨链交易（暂未开放）" },
    { path: '/#', label:"多元化生态系统（暂未开放）" },
    { path: '/#', label:"返回", onClick: () => navigate(-1) },
  ];
  const [mounted, setMounted] = useState(false)

  const { theme, setTheme } = useTheme()

  const changeLanguage = ([lng]) => {
    i18n.changeLanguage(lng);
    setLang(lng)
  }
  const changeTheme = (e) => {
    // console.log(e)
    // if (e) setTheme('light')
    // else setTheme('dark')
  }
  useEffect(() => {
    setTheme('dark')
    setMounted(true)
  }, [])

  if (!mounted) return null
  return (
    <Navbar 
      isBordered={false}
      isMenuOpen={isMenuOpen}
      onMenuOpenChange={setIsMenuOpen}
      classNames={{
        wrapper: 'px-4'
      }}
    >
      <NavbarContent>
         <NavbarMenuToggle
          aria-label={isMenuOpen ? "Close menu" : "Open menu"}
          className="md:hidden outline-none"
        /> 
        <NavbarItem>
          <NavbarBrand >
            <Logo />
          </NavbarBrand>
        </NavbarItem>
      </NavbarContent>

      <NavbarContent className="hidden md:flex gap-2 justify-start items-center" justify={"center"}>
        {menuItems.map((item) => (
          <NavbarItem key={item.label}>
            <Link size={'sm'} color={location.pathname.indexOf(item.path) >= 0 ? 'primary' : 'foreground'} isBlock

              href={item.path}
              // onClick={() => {
              //   navigate(item.path)
              //   setIsMenuOpen(false)
              // }}
            >
              {item.label}

            </Link>
          </NavbarItem>
        ))}
      </NavbarContent>

      <NavbarContent justify="end">
        <NavbarItem>
          <Select
            selectionMode="single"
            selectedKeys={[i18n.language]}
            label=" "
            labelPlacement="outside"
            className="hidden md:block w-[7rem] !mt-0"
            onSelectionChange={changeLanguage}>
            <SelectItem key="en">English</SelectItem>
            <SelectItem key="zh">简体中文</SelectItem>
          </Select>
        </NavbarItem>
        {/* <NavbarItem>
          <Switch

            size="lg"
            // color="success"
            onValueChange={changeTheme}
            startContent={<SunIcon />}
            endContent={<MoonIcon />}
          >
          </Switch>
        </NavbarItem> */}
        <NavbarItem>
          <Connect />
        </NavbarItem>
      </NavbarContent>

      <NavbarMenu onOpenChange={setIsMenuOpen} >
        {menuItems.map((item) => (
          <NavbarMenuItem key={item.label}>

        <Link size={'sm'} color={location.pathname.indexOf(item.path) >= 0 ? 'white' : 'foreground'} isBlock
              className={item.label=== "返回" ? "border mt-6 p-2 pl-[80px] min-w-[200px] text-center justify-items-center p-auto text-white " : ""}
              href={item.path}
              onClick={() => {
                navigate(item.path)
                setIsMenuOpen(false)
              }}
            >
              {item.label}

            </Link>
          </NavbarMenuItem>
        ))}

        {/* <Select
          selectionMode="single"
          selectedKeys={[i18n.language]}
          label=" "
          labelPlacement="outside"
          className="w-full !mt-0"
          onSelectionChange={changeLanguage}>
          <SelectItem key="en">English</SelectItem>
          <SelectItem key="zh">简体中文</SelectItem>
        </Select> */}
      </NavbarMenu>
    </Navbar>
  )
}

export default Header